import Vue from "vue";
import okService from "@/services/okService";

const actions = {
    publication(store, payload) {
        return new Promise((resolve, reject) => {
            okService.publication(payload)
                .then((response) => {
                    resolve(response)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сделать публикацию в ОК.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    getGroups(store, params) {
        return new Promise((resolve, reject) => {
            okService.getGroups(params)
                .then((groups) => {
                    resolve(groups)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список групп из ОК.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    getAlbums(store, params) {
        return new Promise((resolve, reject) => {
            okService.getAlbums(params)
                .then((albums) => {
                    resolve(albums)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список альбомов из ОК.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
    getPhotos(store, params) {
        return new Promise((resolve, reject) => {
            okService.getPhotos(params)
                .then((photos) => {
                    resolve(photos)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить список фото из альбома ОК.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject()
                });
        })
    },
};

export default {
    namespaced: true,
    actions
}